import salesSettingsHelper from "app/pages/sales-intelligence/services/salesSettingsHelper";

import settingsService from "../../advanced-search/services/sw-settings/settingsService";
import type SignalsService from "../models/services/SignalsService";

import createSignalsService from "./factory";
import filterService from "./filters/filterService";

const signalsService: SignalsService = createSignalsService({
    settingsService,
    settingsProvider: salesSettingsHelper,
    filterService,
});

export default signalsService;
